
<div class="container-modal"
  [ngClass]="dataRecieved.status == 2 ? 'max-size' : ''">
  <!-- Encabezado del Modal (solo si el status es 1) -->
  <div class="modal-title d-flex justify-content-between ml-24 mr-24">
    <!-- Skeleton Loader (efecto de carga) -->
    <div class="vw-auto-modal align-items-center">
      <p class="m-0 p-0 fts-20 font-bold-dali">Los siguientes productos serán
        retirados</p>
    </div>

    <!-- Botón de cierre -->
    <div class="button-x justify-content-end d-flex">
      <img
        class="cursor-pointer"
        src="assets/image/modal/close-modal.svg"
        alt="Cerrar"
        width="19px"
        (click)="onNoClick()" />
    </div>
  </div>

  <!-- Línea divisoria (solo si el status es 1) -->
  <hr class="dividing-line-solid mt-10 mb-32 ml-24 mr-24  " />

  <div *ngIf="dataRecieved.status == 2" class="aditional-info ml-24 mr-24">
    <div class="table-responsive">
      <div class="custom-table">
        <!-- Encabezado -->
        <div class="table-header d-flex mb-2">
          <div
            class="col-sku fts-12 line-height-14 font-bold-dali color-title-custom">SKU</div>
          <div
            class="col-description show-desktop-tablet  fts-12 line-height-14 font-bold-dali color-title-custom">Descripción</div>
          <div
            class="col-status ta-r  fts-12 line-height-14 font-bold-dali color-title-custom">Estado</div>
        </div>

        <!-- Filas -->
        <div *ngFor="let element of dataSource" class="table-row mb-2">
          <ng-container *ngIf="element?.recommendedProduct">
            <div class="table-row-2">
              <div
                class=" col-sku pr-2 fts-12 font-regular line-height-14 color-subTitle-custom show-desktop-tablet">{{
                element?.recommendedProduct.sku || element[3] }}</div>
              <div class="show-mobile col-sku-and-description ml-0">
                <div
                  class="fts-12 font-regular line-height-14 color-subTitle-custom">{{
                  element?.recommendedProduct.sku || element[3] }}</div>

                <div
                  class="text-message font-semiBold fts-14 line-height-16 color-title-custom">
                  <p
                    class="mt-0 mb-0 ml-0 mr-0 p-0">{{element?.recommendedProduct.buy_und
                    + '&nbsp;-&nbsp;' + element?.recommendedProduct.description
                    }}</p>
                </div>
              </div>
              <div
                class="col-description text-message font-semiBold fts-14 line-height-16 color-title-custom show-desktop-tablet">
                <p
                  class=" mt-0 mb-0 ml-0 mr-0 p-0">{{element?.recommendedProduct.buy_und
                  + '&nbsp;-&nbsp;' + element?.recommendedProduct.description
                  }}</p> </div>
              <div class="col-status ta-r fts-14 font-bold-dali mr-0 pr-0 text-new-presentation">
                <span
                  class="ta-r fts-14 font-bold-dali new-label">
                  ¡Nueva presentación!
                </span>
              </div>
            </div>
            <hr class="dividing-line-solid m-0" />
          </ng-container>

          <div class="table-row-1">
            <div
              class=" col-sku pr-2 fts-12 font-regular line-height-14 color-subTitle-custom show-desktop-tablet">{{
              element.sku || element[3] }}</div>
            <div class="show-mobile col-sku-and-description">
              <div
                class="fts-12 font-regular line-height-14 color-subTitle-custom">{{
                element.sku || element[3] }}</div>

              <div
                class="text-message font-semiBold fts-14 line-height-16 color-subTitle-custom">
                <p
                  [innerHTML]="![0,1,2,3,4].includes(element.error.type) ? element.buy_und + '&nbsp;-&nbsp;' + element.description : element.error.message"
                  class="mt-0 mb-0 ml-0 mr-0 p-0"></p>
              </div>
            </div>
            <div
              class="col-description text-message font-semiBold fts-14 line-height-16 color-subTitle-custom show-desktop-tablet">
              <p
                [innerHTML]="![0,1,2,3,4].includes(element.error.type) ? element.buy_und + '&nbsp;-&nbsp;' + element.description : element.error.message"
                class="mt-0 mb-0 ml-0 mr-0 p-0"></p>
            </div>
            <div class="col-status ta-r fts-14 font-bold-dali margin-status">
              <span
                class="ta-r fts-14 font-bold-dali"
                [ngClass]="getProductStatus(element)?.class">
                {{ ![0,1,2,3,4].includes(element.error.type)
                ?element.error.message :getProductStatus(element)?.text}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<section>

  <hr class="dividing-line-solid my-3" />

  <div class="buttons ml-24 mr-24">
    <div class="d-flex align-items-center ta-s content-text ">
      <img src="assets/image/focusIcon.svg" alt />
      <div
        class="ta-s ml-16 mr-32 font-regular fts-16 color-title-custom line-height-20"
        [innerHTML]="getTextInfo()">
      </div>
    </div>

    <div class="section-buttons d-flex">
      <button
        class="btn-cancel d-flex justify-content-center align-items-center"
        (click)="onNoClick()" *ngIf="dataRecieved?.validProductExists">
        Cancelar
      </button>
      <button class="btn-green d-flex justify-content-center align-items-center"
        (click)="dataRecieved?.validProductExists?save(1):onNoClick()">
        {{dataRecieved?.validProductExists?'Aceptar y continuar':'Entendido'}}
      </button>

    </div>
  </div>
</section>
</div>
